import { Styled } from './registration-button-iframe.styles';

interface RegistrationButtonProps {
  id: string;
  url?: string;
  numberButtons?: number;
  title?: string;
}

const RegistrationButtonIframe = ({
  id,
  url = 'https://goreg.xing.com',
  numberButtons = 2,
  title = 'XING-Registration',
}: RegistrationButtonProps): JSX.Element => {
  const externalLoginButtonHeight = 64;
  const heightWithoutExternalLoginButtons = 242;
  return (
    <Styled.DivWithCenteredContent>
      <Styled.RegistrationButtonIframe
        src={`${url}/${id}`}
        height={
          heightWithoutExternalLoginButtons +
          numberButtons * externalLoginButtonHeight
        }
        title={title}
      ></Styled.RegistrationButtonIframe>
    </Styled.DivWithCenteredContent>
  );
};

export default RegistrationButtonIframe;
